import { useEffect, useState } from "react";
import { Loader2, PlugZap } from "lucide-react";
import { toast } from "sonner";
import api from "../api";
import { useLanguage } from "../i18n";

/** Card "Accesso API" per account business: richiesta self-service, stato in attesa,
 *  rifiuto, o rimando al tab API quando attiva. L'approvazione resta solo admin. */
export default function ApiAccessCard({ onChanged }) {
  const { t } = useLanguage();
  const [st, setSt] = useState(undefined); // {api_enabled, request}
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/api-access/status").then(({ data }) => setSt(data.data)).catch(() => setSt(null));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (st === undefined) return null;
  if (st === null) return null;

  const request = async () => {
    setBusy(true);
    try {
      await api.post("/api-access/request");
      toast.success(t("admin.saved"));
      await load();
      onChanged?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || t("misc.error"));
    } finally {
      setBusy(false);
    }
  };

  const req = st.request || {};
  return (
    <div data-testid="api-access-card" className="rounded-3xl border border-[var(--border-subtle)] bg-white/60 p-6 sm:p-8 mb-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="max-w-lg">
          <h3 className="font-display font-bold text-lg text-slate-900">{t("apiac.title")}</h3>
          <p className="mt-1 text-sm text-slate-500">{t("apiac.desc")}</p>
        </div>
        {st.api_enabled ? (
          <span data-testid="apiac-enabled" className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 text-emerald-700 px-4 py-2 font-mono-t text-[10px] font-bold uppercase tracking-widest">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" /> {t("apiac.enabled")}
          </span>
        ) : req.status === "pending" ? (
          <span data-testid="apiac-pending" className="rounded-full bg-amber-50 text-amber-700 px-4 py-2 font-mono-t text-[10px] font-bold uppercase tracking-widest">
            {t("apiac.pending")}
          </span>
        ) : (
          <span className="flex flex-col items-end gap-2">
            {req.status === "rejected" && (
              <span data-testid="apiac-rejected" className="text-xs text-red-500">{t("apiac.rejected")}</span>
            )}
            <button data-testid="apiac-request" onClick={request} disabled={busy}
              className="inline-flex items-center gap-2 rounded-full bg-[#1E293B] text-white px-6 py-2.5 font-mono-t text-[10px] font-bold uppercase tracking-widest hover:bg-[#FF6B35] transition-colors disabled:opacity-60">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <PlugZap className="w-3.5 h-3.5" />}
              {t("apiac.request")}
            </button>
          </span>
        )}
      </div>
    </div>
  );
}
